import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, onSnapshot } from 'firebase/firestore';

const CustomerManager = () => {
    const [musteriler, setMusteriler] = useState([]);
    const [yukleniyor, setYukleniyor] = useState(true);
    const [aramaTerimi, setAramaTerimi] = useState("");
    const [seciliMusteri, setSeciliMusteri] = useState(null);

    useEffect(() => {
        // "musteriler" koleksiyonunu dinle
        const musterilerRef = collection(db, "musteriler");
        
        const unsubscribe = onSnapshot(musterilerRef, (snapshot) => {
            const data = [];
            snapshot.forEach((doc) => {
                data.push({ id: doc.id, ...doc.data() });
            });
            
            console.log("Firestore'dan Gelen Veri:", data);
            setMusteriler(data);
            setYukleniyor(false);
        }, (error) => {
            console.error("Firestore Bağlantı Hatası:", error);
            setYukleniyor(false);
        });

        return () => unsubscribe();
    }, []);

    // Filtreleme mantığı: adSoyad alanına göre arama yapar
    const filtrelenmisListe = musteriler.filter(m => {
        const isim = (m.adSoyad || m.ad || "").toLowerCase();
        const tel = (m.tel || m.telefon || "").toLowerCase();
        return isim.includes(aramaTerimi.toLowerCase()) || tel.includes(aramaTerimi);
    });

    if (yukleniyor) return <div className="p-10 text-center font-black italic text-blue-500 animate-pulse">MÜŞTERİLER YÜKLENİYOR...</div>;

    return (
        <div className="flex flex-col gap-6">
            {/* ÜST PANEL */}
            <div className="bg-slate-900 p-6 rounded-[2rem] border border-slate-800 flex flex-wrap gap-4 justify-between items-center shadow-2xl">
                <div>
                    <h1 className="text-xl font-black text-blue-500 italic uppercase tracking-tighter">Müşteri Rehberi</h1>
                    <p className="text-[10px] text-slate-500 font-bold uppercase tracking-widest">{musteriler.length} Kayıtlı Müşteri</p>
                </div>
                <input 
                    placeholder="İsim veya Tel ile hızlı ara..." 
                    className="bg-slate-950 border border-slate-800 p-4 rounded-2xl outline-none focus:border-blue-500 w-full md:w-80 text-sm font-bold shadow-inner text-white"
                    onChange={(e) => setAramaTerimi(e.target.value)}
                />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 h-[70vh]">
                {/* SOL LİSTE */}
                <div className="bg-slate-900 rounded-[2.5rem] border border-slate-800 flex flex-col overflow-hidden shadow-xl">
                    <div className="p-4 border-b border-slate-800 bg-slate-900/50 text-center">
                        <span className="text-[10px] font-black text-slate-500 uppercase tracking-widest">Müşteri Listesi</span>
                    </div>
                    <div className="overflow-y-auto p-3 custom-scrollbar flex-1">
                        {filtrelenmisListe.length === 0 ? (
                            <div className="text-center py-20 text-slate-700 font-bold italic uppercase text-xs">Veri Bulunamadı</div>
                        ) : (
                            filtrelenmisListe.map(m => (
                                <div 
                                    key={m.id} 
                                    onClick={() => setSeciliMusteri(m)}
                                    className={`p-4 mb-2 rounded-2xl cursor-pointer transition-all border flex flex-col gap-1 ${seciliMusteri?.id === m.id ? 'bg-blue-600 border-blue-400 shadow-lg shadow-blue-900/30' : 'bg-slate-950 border-slate-800 hover:border-slate-700'}`}
                                >
                                    <span className="font-black text-[13px] uppercase tracking-tight text-white">{m.adSoyad || "İSİMSİZ"}</span>
                                    <span className="text-[10px] font-bold text-slate-500">{m.tel || m.telefon || "Tel: Yok"}</span>
                                </div>
                            ))
                        )}
                    </div>
                </div>

                {/* SAĞ DETAY KARTI */}
                <div className="md:col-span-2">
                    {seciliMusteri ? (
                        <div className="bg-slate-900 rounded-[3rem] border border-slate-800 p-10 h-full relative shadow-2xl overflow-hidden">
                            <div className="absolute top-0 right-0 p-8 opacity-5 text-9xl font-black italic uppercase pointer-events-none text-white">
                                {seciliMusteri.tip || 'CARİ'}
                            </div>
                            
                            <div className="relative z-10 flex flex-col h-full">
                                <div className="flex items-center gap-6 mb-12">
                                    <div className="w-20 h-20 bg-blue-600 rounded-[2rem] flex items-center justify-center text-3xl font-black italic shadow-2xl shadow-blue-900/40 transform -rotate-3 text-white">
                                        {(seciliMusteri.adSoyad || "M")[0].toUpperCase()}
                                    </div>
                                    <div>
                                        <h2 className="text-4xl font-black uppercase italic tracking-tighter leading-none mb-2 text-white">{seciliMusteri.adSoyad}</h2>
                                        <div className="flex gap-2">
                                            <span className="bg-blue-500/10 text-blue-400 px-3 py-1 rounded-lg text-[9px] font-black uppercase border border-blue-500/20">
                                                ID: {seciliMusteri.id ? seciliMusteri.id.substring(0, 8) : "---"}
                                            </span>
                                            <span className="bg-emerald-500/10 text-emerald-400 px-3 py-1 rounded-lg text-[9px] font-black uppercase border border-emerald-500/20">
                                                {seciliMusteri.tip || "Perakende"}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                                    <div className="bg-slate-950 p-6 rounded-3xl border border-slate-800 shadow-inner">
                                        <p className="text-[10px] font-black text-slate-600 uppercase mb-3 tracking-widest">📞 İletişim Hattı</p>
                                        <p className="text-xl font-bold text-slate-200">{seciliMusteri.tel || seciliMusteri.telefon || "Kayıtlı değil"}</p>
                                    </div>
                                    <div className="bg-slate-950 p-6 rounded-3xl border border-slate-800 shadow-inner">
                                        <p className="text-[10px] font-black text-slate-600 uppercase mb-3 tracking-widest">💰 Güncel Bakiye</p>
                                        <p className="text-3xl font-black text-emerald-500 tracking-tighter italic">₺{seciliMusteri.bakiye || "0,00"}</p>
                                    </div>
                                    <div className="bg-slate-950 p-6 rounded-3xl border border-slate-800 shadow-inner md:col-span-2">
                                        <p className="text-[10px] font-black text-slate-600 uppercase mb-3 tracking-widest">📍 Kayıtlı Adres</p>
                                        <p className="text-sm font-bold text-slate-400 leading-relaxed">{seciliMusteri.adres || "Adres tanımlanmamış."}</p>
                                    </div>
                                </div>

                                <div className="mt-auto flex gap-4">
                                    <button className="flex-1 bg-slate-800 hover:bg-slate-700 py-5 rounded-2xl font-black text-xs uppercase transition-all border border-slate-700 text-white">✏️ KARTI DÜZENLE</button>
                                    <button className="flex-1 bg-blue-600 hover:bg-blue-500 py-5 rounded-2xl font-black text-xs uppercase transition-all shadow-xl shadow-blue-900/30 text-white">🛒 YENİ SİPARİŞ</button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="h-full flex flex-col items-center justify-center border-4 border-dashed border-slate-900 rounded-[3rem] text-slate-800">
                            <span className="text-8xl mb-4">👥</span>
                            <span className="font-black text-2xl uppercase italic opacity-20 text-white">Detay incelemek için müşteri seçin</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CustomerManager;